import MocksDef from '../../Mocks/HeadlessDeliveryMocksDef';
import { HeadlessDeliveryTypes } from '../../Types';
import {
  IMockProps,
  ErrorResponseCodeType,
  MockServiceType,
  Mocks,
} from '../../Core';
import { ENDPOINT_API_PATH, CODE_ERRORS } from '../../Apis/HeadlessDeliveryApi';

/** Mocks de Sucesso */
const mocksSuccess: IMockProps[] = [];

/** Mocks de Erro */
let mocksErrors: IMockProps[] = [];
const generateSuccess = (
  params: {
    flatten: boolean;
    filter: string;
    fields?: string;
  },
  dataResponse: unknown,
): IMockProps => {
  return {
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      params,
    },
    configResponse: {
      status: 200,
      data: dataResponse,
    },
  };
};

const generateDefaultErrors = (): IMockProps[] => {
  return CODE_ERRORS.map(
    (error: ErrorResponseCodeType<null>, index: number): IMockProps => {
      return {
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          params: {
            flatten: true,
            filter: `(friendlyUrlPath eq ${index}-telefones_central)`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };
    },
  );
};

mocksSuccess.push(
  generateSuccess(
    {
      flatten: true,
      filter: "(friendlyUrlPath eq 'telefones_central')",
    },
    MocksDef.TELEFONES_CENTRAL,
  ),
);

mocksSuccess.push(
  generateSuccess(
    {
      flatten: true,
      filter: "(friendlyUrlPath eq 'telefones_central')",
      fields:
        'friendlyUrlPath,contentFields.name,contentFields.contentFieldValue',
    },
    MocksDef.TELEFONES_CENTRAL_FIELDS,
  ),
);

mocksErrors = mocksErrors.concat(generateDefaultErrors());

export const mocksService: MockServiceType<HeadlessDeliveryTypes.HeadlessDeliveryServiceRequestType>[] =
  mocksSuccess.map((request) => ({
    label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
    value: request.configRequest.params,
  }));

const allMocks: IMockProps[] = mocksSuccess.concat(mocksErrors);

Mocks.getInstance().addAll(allMocks);
